import React, { Fragment, PureComponent } from 'react'
import cx from 'classnames'
import Media from 'local_modules/Media'
import config from 'local_modules/app-config'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { compose, getCityName } from 'helpers'

import Text from 'components/typography/Text/Text'

import Logo from './Logo/Logo'
import InfoMenu from './InfoMenu/InfoMenu'
import DateTime from './DateTime/DateTime'
import UserLink from './UserLink/UserLink'
import LoginLink from './LoginLink/LoginLink'
import BurgerMenu from './BurgerMenu/BurgerMenu'
import ChatWidget from './ChatWidget/ChatWidget'
import WeatherWidget from './WeatherWidget/WeatherWidget'
import BurgerMenuList from './BurgerMenuList/BurgerMenuList'

import toggleOpen from 'local_modules/toggleOpen'
import injectGlobals from 'local_modules/injectGlobals'

import s from './Header.scss'


const isTestApi = config.api === 'test'
const isDevApi  = config.env === 'development'


class Header extends PureComponent {

  state = {
    off: null,
    isTitleChanged: false,
    oldTitle: null,
  }

  componentDidMount() {
    actions.ui.getWeather()
    actions.ui.getWeatherCode()
  }

  // componentWillUnmount() {
  //   if (!isTestApi) {
  //     this.removeListeners()
  //   }
  // }

  componentWillReceiveProps({ title }) {
    const { title: oldTitle } = this.props

    if (title !== oldTitle) {
      this.setState({
        isTitleChanged: true,
        oldTitle,
      }, () => {
        setTimeout(() => {
          this.setState({
            isTitleChanged: false,
            oldTitle: null,
          })
        }, 500)
      })
    }
  }

  addListeners = () => {
    this.addListenerLeave()
    this.addListenerEnter()
  }

  removeListeners = () => {
    this.removeListenerLeave()
    this.removeListenerEnter()
  }

  onEnter = () => {
    const { off } = this.state

    if (off) {
      const timeOff = new Date() - off

      if (timeOff > 5000) {
        actions.me.fetch()
      }
    }

    this.setState({
      off: null,
    })
  }

  onLeave = () => {
    this.setState({
      off: new Date(),
    })
  }

  addListenerEnter = () => {
    document.addEventListener('mouseenter', this.onEnter)
  }

  addListenerLeave = () => {
    document.addEventListener('mouseleave', this.onLeave)
  }

  removeListenerEnter = () => {
    document.removeEventListener('mouseenter', this.onEnter)
  }

  removeListenerLeave = () => {
    document.removeEventListener('mouseleave', this.onLeave)
  }

  handleToggleClose = () => {
    const { toggleClose } = this.props

    document.body.classList.remove('overflowHidden')
    toggleClose()
  }

  handleToggleOpen = () => {
    const { toggleOpen } = this.props

    document.body.classList.add('overflowHidden')
    toggleOpen()
  }

  render() {
    const { isTitleChanged, oldTitle } = this.state
    const { title, city, logo, weather: { temp_max } = {}, withCovid, isLoggedIn, isToggleActive, isChatVisible } = this.props

    return (
      <div className={s.container}>
        <div
          className={s.header}
        >
          <div className={s.left}>
            <BurgerMenu
              isToggleActive={isToggleActive}
              onClick={isToggleActive ? this.handleToggleClose : this.handleToggleOpen}
            />
            <Logo city={city} logo={logo} />
            <div className={cx(s.title, { [s.changed]: isTitleChanged })}>
              <div className={s.text}>{oldTitle || title}</div>
            </div>
          </div>
          <div className={s.right}>
            <Media desktop>
              {
                (isDesktop) => isDesktop && (
                  <Fragment>
                    {
                      Boolean(withCovid) && (
                        <Text
                          className={s.covid}
                          message="Горячая линия по коронавирусу +7 (83130) 9-77-77"
                        />
                      )
                    }
                    <DateTime className={s.desktop} />
                  </Fragment>
                )
              }
            </Media>
            <Media mobile>
              {
                (isMobile) => !isMobile && (
                  <Fragment>
                    {
                      Boolean(typeof temp_max !== 'undefined') && (
                        <WeatherWidget
                          interval={200000}
                        />
                      )
                    }
                    {
                      Boolean(isChatVisible || isDevApi) && (
                        <ChatWidget
                          interval={20000}
                        />
                      )
                    }
                  </Fragment>
                )
              }
            </Media>
            {
              isLoggedIn ? (
                <UserLink />
              ) : (
                <LoginLink />
              )
            }
            <InfoMenu />
          </div>
        </div>
        <BurgerMenuList
          className={cx(s.burgerMenuList, { [s.active]: isToggleActive })}
        />
      </div>
    )
  }
}


export default compose(
  injectGlobals(({ globals }) => ({
    city: getCityName(globals),
    // withCovid: getCityName(globals) === 'sarov',
  })),
  connect({
    logo: 'me.city.logo106x40',
    weather: 'ui.weather',
    isChatVisible: 'me.seeChat',
    isLoggedIn: 'me.isLoggedIn',
    title: (state) => {
      const { me: { layers } } = state
      const { routing: { locationBeforeTransitions: { pathname } } } = state

      let pageTitle = ''

      layers.some(({ id, link, title }) => {
        return pathname.includes(link) ? pageTitle = title : false
      })

      return pageTitle
    },
  }),
  toggleOpen(),
)(Header)
